import {
  createValidation,
  validatorLength,
  validatorMaxLength,
  validatorNumber,
  validatorRequired,
} from '../../utils/formValidators';
import { externalRegistry } from '../../constants/parameters';
import { tCommon as t } from '../../i18n';

const validatorRequiredMemberCode = () => (field, form) =>
  form.get(externalRegistry.ACTIVE) === true ? validatorRequired()(field) : '';

export default createValidation([
  {
    name: externalRegistry.CODE,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorMaxLength(13)(field),
    ],
  },
  {
    name: externalRegistry.ESTONIAN,
    validators: [(field) => validatorRequired()(field)],
  },
  {
    name: externalRegistry.ENGLISH,
    validators: [(field) => validatorRequired()(field)],
  },
  {
    name: externalRegistry.COUNTRY_CODE,
    validators: [(field) => validatorRequired()(field)],
  },
  {
    name: externalRegistry.MEMBER_CODE,
    validators: [
      (field, form) => validatorRequiredMemberCode()(field, form),
      (field) => validatorNumber()(field),
      (field) =>
        validatorLength(2, t('form_field_digit_length', { length: 2 }))(field),
    ],
  },
]);
